import { invoiceRequest } from '@services'
import { Notify } from 'vant'
export default {
  namespaced: true,
  state: {
    detailData: {}
  },
  mutations: {
    setDetailData (state, detailData) {
      state.detailData = detailData
    }
  },
  actions: {
    async getInvoiceInfo ({ commit }, id) {
      const data = await invoiceRequest.apply.getApplyDetail({ id })
      if (data.success) {
        await commit('setDetailData', data.result)
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    }
  }
}
